const stringToHashNumber = (str: string) =>
  str.split('').reduce((hash, _, i) => hash + str.charCodeAt(i), 0);

export default stringToHashNumber;
